import type { ReactNode } from 'react';
import { formatNumber } from '../../lib/format';

/**
 * A single number that needs no plot. Large standalone figures use the
 * default proportional figures — tabular widths are for columns that have
 * to line up, not for a headline.
 */
export function StatTile({
  label,
  value,
  hint,
  tone = 'default',
  icon,
}: {
  label: string;
  value: number | string;
  hint?: string;
  tone?: 'default' | 'live';
  icon?: ReactNode;
}) {
  return (
    <div
      className={`panel px-4 py-3.5 ${
        tone === 'live' ? 'border-live/35 bg-live-wash' : ''
      }`}
    >
      <div className="flex items-center gap-1.5 text-xs text-ink-3">
        {icon}
        {label}
      </div>
      <div
        className={`mt-1.5 text-[1.75rem] font-light leading-none tracking-[-0.02em] ${
          tone === 'live' ? 'text-live-text' : 'text-ink'
        }`}
      >
        {typeof value === 'number' ? formatNumber(value) : value}
      </div>
      {hint && <div className="mt-1.5 text-[0.6875rem] text-ink-3">{hint}</div>}
    </div>
  );
}
